import axios from 'axios'; 
import React, { useState, useEffect, useRef } from 'react';
import ReactModal from 'react-modal';
import NavbarMex from '../components/navbarMex';
import BotonWhatsapp from '../botonWhatsapp/botonWhatsapp';
import { message, Select, Modal, Alert, Button, Tooltip } from 'antd';
import { InfoCircleOutlined, WarningOutlined } from '@ant-design/icons';
import { useParams } from 'react-router-dom'; // Importa useParams
import Ciudades from '../../ciudades/ciudades';
import './ShippingForm.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTruck, faStar, faArrowRight, faCoins, faBolt } from '@fortawesome/free-solid-svg-icons';
// Importamos el componente ManifiestoGenerator
import ManifiestoGenerator from '../envioCompleto/manifestoGenerator';

const { Option } = Select;

// Añade esta función helper fuera del componente
const TransportadoraCard = ({ data, selected, onSelect, type, formData }) => {
  if (!data) return null;
  
  const {
    valor = 0,
    sobreflete = 0,
    valor_contrapago = 0,
    seguro99 = 0
  } = data;

  const total = valor + sobreflete + valor_contrapago + seguro99;
  const valorDeclarado = parseFloat(formData?.declaredValue || 0);
  const valorACobrar = valorDeclarado - total;

  return (
    <div 
      className={`transportadora-card-horizontal ${selected ? 'selected' : ''}`}
      onClick={() => onSelect(type)}
    >
      <div className="transportadora-logo-horizontal">
        <img src={getTransportadoraImage(type)} alt={type} onError={(e) => {
          console.error(`Error loading image for ${type}`);
          e.target.src = '/Images/default.png';
        }} />
      </div>
      <div className="transportadora-info-horizontal">
        <div className="price-breakdown">
          {formData?.cashOnDelivery ? (
            <>
              <div className="price-item">
                <span>Valor a cobrar:</span>
                <span className="amount">${valorDeclarado.toLocaleString()}</span>
              </div>
              <div className="price-item">
                <span>Costo del envío:</span>
                <span className="amount negative">-${total.toLocaleString()}</span>
              </div>
              <div className="price-item total">
                <span>Te entregarán:</span>
                <span className="amount">${valorACobrar.toLocaleString()}</span>
              </div>
            </>
          ) : (
            <div className="price-item total">
              <span>Costo del envío:</span>
              <span className="amount">${total.toLocaleString()}</span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

const getTransportadoraImage = (name) => {
  const images = {
    'interrapidisimo': 'inter.png',
    'tcc': 'tcc.svg',
    'servientrega': 'servi.png',
    'coordinadora': 'coordi.png'
  };
  
  return `/Images/${images[name] || 'default.png'}`;
};

const ShippingForm = () => {
  const { id } = useParams(); // Obtiene el id desde la URL
  const [cotizacionResult, setCotizacionResult] = useState(null);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [guiaModalIsOpen, setGuiaModalIsOpen] = useState(false); // Nuevo estado para el modal de la guía
  const [costoEnvioButtonDisabled, setCostoEnvioButtonDisabled] = useState(false); // Nuevo estado para el botón
  const [volumetricWeight, setVolumetricWeight] = useState(0);
  const [finalWeight, setFinalWeight] = useState(0);
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [selectedTransportadora, setSelectedTransportadora] = useState(null);
  const [attemptedSubmit, setAttemptedSubmit] = useState(false);
  const [sucursalId, setSucursalId] = useState(null);
  const [formattedValue, setFormattedValue] = useState('');
  const [cotizarDisabled, setCotizarDisabled] = useState(false);
  const [generarGuiaDisabled, setGenerarGuiaDisabled] = useState(false);
  const [confirmationMessage, setConfirmationMessage] = useState('');
  const [numeroPreenvio, setNumeroPreenvio] = useState('');
  const confirmationRef = useRef(null);
  const [activeCarrier, setActiveCarrier] = useState(null);
  const [isResponsive, setIsResponsive] = useState(window.innerWidth <= 768);
  const [isTransportadoraModalOpen, setIsTransportadoraModalOpen] = useState(false);
  const [offices, setOffices] = useState([]);
  const [selectedOffice, setSelectedOffice] = useState('');
  const [isErrorModalVisible, setIsErrorModalVisible] = useState(false);
  const [errorModalMessage, setErrorModalMessage] = useState('');
  const [statusWhatsapp, setStatusWhatsapp] = useState(false);
  const [isWhatsappModalVisible, setIsWhatsappModalVisible] = useState(false);
  const [whatsappNumber, setWhatsappNumber] = useState('');
  const [emailError, setEmailError] = useState('');
  const [modalMessage, setModalMessage] = useState(null); // Añadir estado para mensajes modales
  const [seguroDisabledByPercentage, setSeguroDisabledByPercentage] =
    useState(false); // Estado para controlar si el seguro está desactivado por porcentaje
  //const [seguroPayMessage, setSeguroPayMessage] = useState(false);
  const [desactivateSeguroPlus, setDesactivateSeguroPlus] = useState(false);
  const [isVisibleModalWarning, setIsVisibleModalWarning] = useState(false);
  const [selectedTamanoGuia, setSelectedTamanoGuia] = useState('2');

  const fetchModalMessage = async () => {
    try {
      const response = await axios.get('https://99envios.app/api/online/modals');
      if (response.data && response.data.activo) {
        setModalMessage(response.data);
      }
    } catch (error) {
      console.error('Error al obtener el mensaje del modal', error);
    }
  };

  const checkSeguroAntidevoluciones = async () => {
    try {
      const user_id = localStorage.getItem('usuario_id');
      if (!user_id) return;

      const response = await axios.get(`https://99envios.app/api/online/sucursal/${user_id}`);
      const porcentajeEstado5 = response.data.porcentaje_estado_5;
      if (porcentajeEstado5 >= 0.4) {
        setSeguroDisabledByPercentage(true);
        setDesactivateSeguroPlus(true);
        

        // Desactivar el seguro en el formData
        setFormData((prevState) => ({
          ...prevState,
          seguro99: false,
        })); 
       /*}  else if (porcentajeEstado5 >= 0.2 && porcentajeEstado5 < 0.39) {
        setSeguroPayMessage(true);  */
      } else if (porcentajeEstado5 >= 0.35) {
        setDesactivateSeguroPlus(true);
      } else {
        setSeguroDisabledByPercentage(false);
      }
    } catch (error) {
      console.error('Error al verificar porcentaje de estado 5:', error);
    }
  };

  useEffect(() => {
    fetchModalMessage();
    checkSeguroAntidevoluciones();
  }, []);

  const showErrorModal = (message) => {
    // Cerrar el modal de cotización si está abierto
    if (modalIsOpen) {
      setModalIsOpen(false);
    }
    setErrorModalMessage(message);
    setIsErrorModalVisible(true);
  };

  const handleErrorModalCancel = () => {
    setIsErrorModalVisible(false);
  };

  useEffect(() => {
    const handleResize = () => {
      setIsResponsive(window.innerWidth <= 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (confirmationRef.current && !confirmationRef.current.contains(event.target)) {
        setConfirmationMessage('');
      }
    };

    document.addEventListener('mousedown', handleClickOutside);

    // Limpieza del evento
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const initialFormDataGuia = {
    fecha: '',
    AplicaContrapago: false,
    seguro99: false,
    seguro99plus: false,
    Peso: '',
    Largo: '',
    Ancho: '',
    Alto: '',
    DiceContener: '',
    ValorDeclarado: '',
    tipoDocumento: '',
    numeroDocumento: '',
    nombre: '',
    primerApellido: '',
    segundoApellido: '',
    telefono: '',
    direccion: '',
    correo: '',
    idLocalidad: '',
    Observaciones: ''
  };

  const [formDataGuia, setFormDataGuia] = useState(initialFormDataGuia);

  const closeModal = () => {
    setGuiaModalIsOpen(false);
    setCostoEnvioButtonDisabled(false); // Reset button state when modal closes
  };

  const handleInputChange = (event) => {
    const { name, value, type, checked } = event.target;
    const updatedValue = type === 'checkbox' ? checked : value;
    
    // Remove the required-missing class when a user starts typing in a field
    if (event.target.classList.contains('required-missing')) {
      event.target.classList.remove('required-missing');
    }

    if(name === 'correo') {
      setFormDataGuia({
        ...formDataGuia,
        [name]: value,
      });
      if (!/^\S+@\S+\.\S+$/.test(value)) {
        setEmailError("El correo electrónico no es válido");
      } else {
        setEmailError('');
      }
      return;
    }
    
    if (name === 'DiceContener') {
      setFormDataGuia({
        ...formDataGuia,
        [name]: updatedValue,
        Observaciones: updatedValue // Actualiza también Observaciones
      });
    } else {
      setFormDataGuia({
        ...formDataGuia,
        [name]: updatedValue,
      });
    }

    if (name === 'Peso' || name === 'ValorDeclarado') {
      const peso = name === 'Peso' ? parseFloat(updatedValue) : parseFloat(formDataGuia.Peso);
      const valorDeclarado = name === 'ValorDeclarado' ? parseFloat(updatedValue) : parseFloat(formDataGuia.ValorDeclarado);

      let valorDeclaradoMinimo;
      if (peso >= 1 && peso <= 2) {
        valorDeclaradoMinimo = 25000;
      } else if (peso >= 3 && peso <= 5) {
        valorDeclaradoMinimo = 40000;
      } else if (peso >= 6) {
        valorDeclaradoMinimo = 50000;
      }

      if (valorDeclarado < valorDeclaradoMinimo) {
        setErrorMessage(`El valor declarado debe ser al menos ${valorDeclaradoMinimo} para un peso de ${peso} kg.`);
      } else {
        setErrorMessage('');
      }
    }
  };

  useEffect(() => {
    if (id) {
      localStorage.setItem('id', id);
    }
  }, [id]);

  useEffect(() => {
    setFormData({
      destinationCity: '',
      declaredValue: '50000',
      deliveryType: 'direccion',
      shipmentType: 'paquete',
      grossWeight: '1',
      length: '10',
      width: '10',
      height: '10',
      contentDescription: '',
      observations: '',
      cashOnDelivery: true,
      seguro99: true,
      seguro99plus: false,
    });
  }, []);

  const [formData, setFormData] = useState({
    destinationCity: '',
    declaredValue: '50000',
    deliveryType: '',
    shipmentType: '',
    grossWeight: '',
    length: '',
    width: '',
    height: '',
    contentDescription: '',
    observations: '',
    cashOnDelivery: true,
    seguro99: true,
    seguro99plus: false,
  });

  const parseCurrency = (value) => {
    return parseFloat(value.replace(/[^0-9.-]+/g, ""));
  };

  const [formattedDeclaredValue, setFormattedDeclaredValue] = useState('');

  useEffect(() => {
    // Formatear el valor declarado inicial
    setFormattedDeclaredValue(formatCurrency(formData.declaredValue));
  }, []);

  const formatCurrency = (value) => {
    return new Intl.NumberFormat('es-CO', { style: 'currency', currency: 'COP', minimumFractionDigits: 0 }).format(value);
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    // Validación para peso bruto - no menor o igual a 0
    if (name === 'grossWeight') {
      const numericValue = parseFloat(value);
      if (numericValue <= 0) {
        return; // No permitir valores negativos o cero
      }
    }
    
    if (name === 'seguro99') {
      // Si está desactivado por porcentaje, no permitir cambios

      //modal to show when seguro99 is disabled
      if (checked && seguroDisabledByPercentage) { 
        setIsVisibleModalWarning(true);
        return;
      }

      // Si el pago contra entrega está desactivado, no permitir cambios en seguro99
      if (!formData.cashOnDelivery) {
        return;
      }
      
      // Si se está activando seguro99, desactivar seguro99Plus
      if (checked) {
        setFormData(prevState => ({
          ...prevState,
          seguro99: true,
          seguro99plus: false
        }));
        return;
      }
      
      if (!checked) {
        // Show warning modal when unchecking
        Modal.warning({
          icon: null,
          title: (
            <div style={{
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              color: '#f5a623',
              marginBottom: '0'
            }}>
              <WarningOutlined style={{ fontSize: '20px' }} />
              <span style={{ fontSize: '16px', fontWeight: '500' }}>Seguro Antidevoluciones desactivado</span>
            </div>
          ),
          content: (
            <div style={{
              marginTop: '16px',
              background: '#fff9e6',
              padding: '16px',
              borderRadius: '8px',
              border: '1px solid #ffd666'
            }}>
              <p style={{
                margin: 0,
                color: '#595959',
                fontSize: '14px',
                textAlign: 'center',
                lineHeight: '1.5'
              }}>
                Al desactivar esta opción, deberás asumir el costo del envío de ida en caso de que el pedido sea devuelto.
              </p>
            </div>
          ),
          okText: 'Entendido',
          centered: true,
          width: 420,
          className: 'seguro99-warning-modal',
          okButtonProps: {
            style: {
              backgroundColor: '#f5a623',
              borderColor: '#f5a623',
              borderRadius: '4px',
              height: '32px',
              fontWeight: '500'
            }
          },
          onOk() {
            setFormData(prevState => ({
              ...prevState,
              seguro99: false
            }));
          },
          maskClosable: true,
          centered: true,
          width: 480,
          className: 'seguro99-warning-modal'
        });
      }
      return;
    }

    if (name === 'seguro99plus') {
      // Si el pago contra entrega está desactivado, no permitir cambios en seguro99Plus
      if (!formData.cashOnDelivery) {
        return;
      }
      
      if(checked && desactivateSeguroPlus) {
        setFormData(prevState => ({
          ...prevState,
          seguro99plus: false
        }));
        return;
      }


      
      // Si se está activando seguro99Plus, desactivar seguro99
      if (checked) {
        setFormData(prevState => ({
          ...prevState,
          seguro99: false,
          seguro99plus: true
        }));
        return;
      } else {
        setFormData(prevState => ({
          ...prevState,
          seguro99plus: false
        }));
      }
      return;
    }

    if (name === 'deliveryType') {
      if (value === 'centroAcopio') {
        Modal.info({
          title: 'Aviso Importante',
          content: 'El servicio de entrega en oficina solo está disponible con Interrapidisimo.',
          okText: 'Entendido',
          okButtonProps: { style: { height: '44px' } },
        });
      }
      setFormData(prevState => ({
        ...prevState,
        [name]: value,
        seguro99: prevState.seguro99 // Aseguramos que seguro99 no se modifique
      }));
      setFormDataGuia(prevState => ({
        ...prevState,
        numeroDocumento: ''
      }));
      return;
    }

    if (name === 'declaredValue') {
      // Eliminar todos los caracteres no numEricos
      const numericValue = value.replace(/[^0-9]/g, '');
      const parsedValue = numericValue ? parseInt(numericValue, 10) : 0;

      // Actualizar el estado con el valor numErico sin restricciones
      setFormData(prevState => ({
        ...prevState,
        [name]: parsedValue
      }));

      // Actualizar el valor formateado
      setFormattedDeclaredValue(formatCurrency(parsedValue));
    } else if (name === 'cashOnDelivery') {
      // Show alert when unchecking cashOnDelivery
      if (!checked) {
        Modal.confirm({
          title: 'Aviso Importante',
          content: 'Si decides realizar la guía sin contra pago, ten en cuenta que se generará un cobro directo a tu saldo. Para proceder con la anulación y la devolución del pago realizado, este proceso puede tomar entre 7 y 15 días hábiles. Es importante que estés completamente seguro de realizar esta acción, ya que el proceso involucra varios pasos y lleva un tiempo para ser completado.',
          okText: 'Entendido',
          cancelText: 'Cancelar',
          okButtonProps: { style: { height: '44px' } },
          cancelButtonProps: { style: { height: '44px' } },
          onOk() {
            setFormData(prevState => ({
              ...prevState,
              [name]: checked,
              // Si se desactiva el pago contra entrega, también desactivar el seguro
              seguro99: checked ? prevState.seguro99 : false,
              seguro99plus: checked ? prevState.seguro99plus : false
            }));
          },
          onCancel() {
            // If user cancels, keep checkbox checked
            setFormData(prevState => ({
              ...prevState,
              [name]: true,
              seguro99: prevState.seguro99
            }));
          }
        });
      } else {
        setFormData(prevState => ({
          ...prevState,
          [name]: checked
        }));
      }
    } else {
      // Para otros campos, mantener la lógica existente
      const updatedValue = type === 'checkbox' ? checked : value;
      setFormData(prevState => ({
        ...prevState,
        [name]: updatedValue
      }));
    }

    if (name === 'deliveryType') {
      setFormDataGuia(prevState => ({
        ...prevState,
        numeroDocumento: ''
      }));
    }
  };

  useEffect(() => {
    if (formData.declaredValue) {
      const numValue = parseInt(formData.declaredValue, 10);
      if (!isNaN(numValue)) {
        const formattedBalance = numValue.toLocaleString('es-CO', {
          style: 'currency',
          currency: 'COP',
          minimumFractionDigits: 0,
          maximumFractionDigits: 0
        });
        setFormattedValue(formattedBalance);
      } else {
        setFormattedValue('');
      }
    } else {
      setFormattedValue('');
    }
  }, [formData.declaredValue]);

  const handleBlur = (e) => {
    const { name, value } = e.target;
    if (name === 'declaredValue') {
      const parsedValue = parseCurrency(value);
      setFormData({
        ...formData,
        declaredValue: parsedValue,
        declaredValueFormatted: formatCurrency(parsedValue)
      });
    }
  };

  useEffect(() => {
    const largo = parseFloat(formData.length) || 0;
    const ancho = parseFloat(formData.width) || 0;
    const alto = parseFloat(formData.height) || 0;
    const pesoVolumetrico = (largo * ancho * alto) / 6000;
    setVolumetricWeight(pesoVolumetrico.toFixed(2));
    console.log('Peso volumEtrico:', pesoVolumetrico);
  }, [formData.length, formData.width, formData.height]);

  useEffect(() => {
    const peso = parseFloat(formData.grossWeight);
    const PesoVolumetrico = parseFloat(volumetricWeight);
    const valorDeclarado = parseFloat(formData.declaredValue);
    let valorDeclaradoMinimo;

    if (peso > PesoVolumetrico) {
      if (peso >= 1 && peso <= 2) {
        valorDeclaradoMinimo = 25000;
      } else if (peso >= 3 && peso <= 5) {
        valorDeclaradoMinimo = 40000;
      } else if (peso >= 6) {
        valorDeclaradoMinimo = 50000;
      }

      if (valorDeclarado < valorDeclaradoMinimo) {
        const errorMsg = `El valor declarado debe ser al menos ${valorDeclaradoMinimo} para un peso de ${peso} kg.`;
        setErrorMessage(errorMsg);

      } else {
        setErrorMessage('');
      }
    } else {
      if (PesoVolumetrico >= 1 && PesoVolumetrico <= 2) {
        valorDeclaradoMinimo = 25000;
      } else if (PesoVolumetrico >= 3 && PesoVolumetrico <= 5) {
        valorDeclaradoMinimo = 40000;
      } else if (PesoVolumetrico >= 6) {
        valorDeclaradoMinimo = 50000;
      }

      if (valorDeclarado < valorDeclaradoMinimo) {
        const errorMsg = `El valor declarado debe ser al menos ${valorDeclaradoMinimo} para un peso de ${PesoVolumetrico} kg.`;
        setErrorMessage(errorMsg);

      } else {
        setErrorMessage('');
      }
    }
  }, [formData.grossWeight, formData.declaredValue, volumetricWeight, attemptedSubmit]);

  const pesoBruto = parseFloat(formDataGuia.Peso);
  const pesoVolumetrico = parseFloat(volumetricWeight);
  const pesoFinal = pesoVolumetrico > pesoBruto ? pesoVolumetrico : pesoBruto;
  console.log('Peso final:', pesoFinal);
  console.log('PesoVolumetrico:', pesoVolumetrico);

  const handleGuiaSubmit = async (e) => {
    e.preventDefault();
    if (generarGuiaDisabled) return; // Evita clicks durante el cooldown
    setGenerarGuiaDisabled(true);

    // Reset all fields' style by removing required-missing class
    document.querySelectorAll('.input-field').forEach(input => {
      input.classList.remove('required-missing');
    });
    
    // Validar el correo electrónico
    if (!/^\S+@\S+\.\S+$/.test(formDataGuia.correo)) {
      message.error("El correo electrónico no es válido");
      setGenerarGuiaDisabled(false);
      const emailInput = document.getElementById('correo');
      if (emailInput) {
        emailInput.classList.add('required-missing');
        emailInput.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
      return;
    }

    // Antes de validar el saldo, asegura cerrar el modal de cotización si está abierto
    if (modalIsOpen) {
      setModalIsOpen(false);
    }

    // Validar que hay suficiente saldo si no es contrapago
    if (!formDataGuia.AplicaContrapago) {
      // Obtener el valor de la cotización
      const transportadoraSeleccionada = cotizacionResult[selectedTransportadora];
      if (transportadoraSeleccionada) {
        const valorTotal = (transportadoraSeleccionada.valor || 0) +
          (transportadoraSeleccionada.comision_interna || 0) +
          (transportadoraSeleccionada.sobreflete || 0);

        // Convertir el saldo disponible a número
        const saldoDisponibleNum = parseFloat(availableBalance);

        if (valorTotal > saldoDisponibleNum) {
          showErrorModal('El saldo disponible no es suficiente para generar la guía sin contrapago.');
          setGenerarGuiaDisabled(false);
          return;
        }
      }
    }

    const requiredFields = [
      'nombre',
      'primerApellido',
      'telefono',
      'direccion',
      'correo',
      'DiceContener'
    ];

    if (formData.deliveryType === 'centroAcopio') {
      requiredFields.push('numeroDocumento');
    }

    const missingFields = requiredFields.filter(field => !formDataGuia[field]);

    if (missingFields.length > 0) {
      // Highlight missing fields in red
      missingFields.forEach(field => {
        const input = document.getElementById(field);
        if (input) {
          input.classList.add('required-missing');
        }
      });
      
      // Scroll to the first missing field
      const firstMissingField = document.getElementById(missingFields[0]);
      if (firstMissingField) {
        firstMissingField.scrollIntoView({ behavior: 'smooth', block: 'center' });
        firstMissingField.focus();
      }
      
      message.error(`Los siguientes campos son obligatorios: ${missingFields.join(', ')}`);
      setGenerarGuiaDisabled(false);
      return;
    }

    const idLocalidad = formDataGuia.idLocalidad;
    if (!idLocalidad) {
      alert('El valor de ciudad no es válido');
      setGenerarGuiaDisabled(false);
      return;
    }

    const guiaData = {
      IdTipoEntrega: formData.deliveryType === 'direccion' ? 1 : 2,
      IdServicio: formData.shipmentType === 'paquete' ? 1 : 2,
      AplicaContrapago: formDataGuia.AplicaContrapago || false,
      seguro99: formDataGuia.seguro99 || false,
      seguro99plus: formDataGuia.seguro99plus || false,
      peso: pesoFinal,
      largo: parseFloat(formDataGuia.Largo) || 1,
      ancho: parseFloat(formDataGuia.Ancho) || 1,
      alto: parseFloat(formDataGuia.Alto) || 1,
      diceContener: formDataGuia.DiceContener || " ",
      valorDeclarado: Math.round(parseFloat(formDataGuia.ValorDeclarado)) || 50000,
      Destinatario: {
        tipoDocumento: formDataGuia.tipoDocumento || "CC",
        numeroDocumento: formDataGuia.numeroDocumento || " ",
        nombre: formDataGuia.nombre || "  ",
        primerApellido: formDataGuia.primerApellido || " ",
        segundoApellido: formDataGuia.segundoApellido || " ",
        telefono: formDataGuia.telefono || " ",
        direccion: formDataGuia.direccion || " ",
        correo: formDataGuia.correo || " ",
        idLocalidad: formDataGuia.idLocalidad || " "
      },
      Observaciones: formDataGuia.DiceContener || " ",
      transportadora: {
        pais: "colombia",
        nombre: selectedTransportadora,
        aplicaContrapago: formDataGuia.AplicaContrapago
      },
      origenCreacion: 1,
    };

    try {
      const token = localStorage.getItem('token');
      const response = await fetch(`https://integration.99envios.app/api/sucursal/preenvio/${sucursalId}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': token ? `Bearer ${token}` : ''
        },
        body: JSON.stringify(guiaData)
      });

      if (!response.ok) {
        const errorData = await response.json();
        const errorMessage = errorData.mensaje_completo ? errorData.mensaje_completo.join(' ') : errorData.mensaje;
        alert(`Error: ${errorMessage}`);
        throw new Error('Error en la respuesta del servidor');
      }

      const data = await response.json();
      const numeroPreenvio = data.numeroPreenvio.toString();
      setNumeroPreenvio(numeroPreenvio);

      const pdfData = {
        transportadora: {
          pais: "colombia",
          nombre: selectedTransportadora
        },
        guia: numeroPreenvio,
        AplicaContrapago: formDataGuia.AplicaContrapago,
        origenCreacion: 1,
      };

      const pdfResponse = await fetch(
        `https://integration.99envios.app/api/sucursal/pdf/${sucursalId}/${selectedTamanoGuia}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: token ? `Bearer ${token}` : "", // Si usas autenticación
          },
          body: JSON.stringify({
            transportadora: {
              pais: "colombia",
              nombre: selectedTransportadora,
            },
            guia: numeroPreenvio,
            AplicaContrapago: formDataGuia.AplicaContrapago,
            origenCreacion: 1,
          }),
        }
      );

      if (pdfResponse.ok) {
        const pdfUrl = await pdfResponse.text(); // O usa json() si responde con JSON
        if (pdfUrl) {
          window.open(pdfUrl.trim(), '_blank'); // Asegúrate de abrir correctamente
          // Cerrar el modal de transportadoras
          setIsTransportadoraModalOpen(false);
          setModalIsOpen(false);
        } else {
          console.error('No se pudo obtener una URL válida del PDF.');
          alert('Error: No se pudo generar el PDF.');
        }
      } else {
        const errorData = await pdfResponse.json();
        const errorMessage = errorData?.mensaje || 'Error desconocido al generar el PDF';
        console.error('Error al generar el PDF:', errorMessage);
        alert(`Error: ${errorMessage}`);
      }

      setConfirmationMessage('Tu guía se ha generado con éxito.');
      setGuiaModalIsOpen(false); // Cerramos el modal de guía en vez de modalIsOpen
      console.log("estado de whatsapp", statusWhatsapp)

      if (statusWhatsapp) {
        console.log("intentando", numeroPreenvio)
        try {
          const whatsappResponse = await axios.post(`https://99envios.app/api/online/whatsapp/message_template_envios/${numeroPreenvio}`, {});
          if (whatsappResponse.data.messaging_product === "whatsapp" && 
              whatsappResponse.data.contacts && 
              whatsappResponse.data.contacts.length > 0 &&
              whatsappResponse.data.messages &&
              whatsappResponse.data.messages[0].message_status === "accepted") {
            const whatsappNumber = whatsappResponse.data.contacts[0].input;
            setConfirmationMessage(`Tu guía número ${numeroPreenvio} de ${selectedTransportadora} se ha generado con éxito. Puedes consultar en Envíos Completo.\n\nSe ha enviado un mensaje de WhatsApp de confirmación al número: ${whatsappNumber}`);
          } else {
            setConfirmationMessage(`Tu guía número ${numeroPreenvio} de ${selectedTransportadora} se ha generado con éxito. Puedes consultar en Envíos Completo.`);
          }
        } catch (whatsAppError) {
          console.error('Error enviando WhatsApp:', whatsAppError);
          setConfirmationMessage(`Tu guía número ${numeroPreenvio} de ${selectedTransportadora} se ha generado con éxito. Puedes consultar en Envíos Completo.`);
        }
      } else {
        setConfirmationMessage(`Tu guía número ${numeroPreenvio} de ${selectedTransportadora} se ha generado con éxito. Puedes consultar en Envíos Completo.`);
      }

      // Solo reiniciamos los datos del formulario de guía, manteniendo los datos iniciales
      setFormDataGuia({
        fecha: '',
        AplicaContrapago: false,
        Peso: '',
        Largo: '',
        Ancho: '',
        Alto: '',
        DiceContener: '',
        ValorDeclarado: '',
        tipoDocumento: '',
        numeroDocumento: '',
        nombre: '',
        primerApellido: '',
        segundoApellido: '',
        telefono: '',
        direccion: '',
        correo: '',
        idLocalidad: '',
        Observaciones: ''
      });

      // Reset solo los estados relacionados con la guía
      setSelectedTransportadora(null);
      setCotizacionResult(null);
      setSelectedOffice('');
      setEmailError('');

      // Ya no reiniciamos formData ni volumetricWeight para mantener los datos iniciales

    } catch (error) {
      console.error('Error:', error);
      message.error('Error al generar la guía');
    } finally {
      setTimeout(() => {
        setGenerarGuiaDisabled(false);
      }, 3000);
    }
  };

  useEffect(() => {
    const fetchSucursalId = async () => {
      try {
        const response = await fetch(`https://99envios.app/api/online/sucursal-codigo-sucursal/${id}`);
        if (!response.ok) {
          throw new Error('Error fetching sucursal ID');
        }
        const data = await response.json();
        console.log('Sucursal ID:', data);
        setSucursalId(data);
      } catch (error) {
        console.error('Error fetching sucursal ID:', error);
        return null;
      }
    };

   
    fetchSucursalId();
  }, [id]);

  useEffect(() => {
    const fetchSucursalData = async () => {
      try {
  
        const sucursalResponse = await axios.get(`https://99envios.app/api/online/sucursal/${id}`);
        setStatusWhatsapp(sucursalResponse.data.status_whatsapp === 1);
        console.log('Status WhatsApp:', sucursalResponse.data.status_whatsapp);
      } catch (error) {
        console.error('Error fetching sucursal data:', error);
      }
    };

    fetchSucursalData();
    console.log("estado wha",statusWhatsapp)
  }, [sucursalId]);




  const handleSubmit = async (e) => {
    e.preventDefault();
    if (cotizarDisabled) return;
    
    // Validar que se haya seleccionado una ciudad
    if (!formData.destinationCity) {
      message.error('Por favor seleccione una ciudad de destino');
      // Encuentra el select de ciudad y añade la clase de error
      const citySelect = document.querySelector('.ant-select-selector');
      if (citySelect) {
        citySelect.style.borderColor = '#ff4d4f';
        citySelect.style.boxShadow = '0 0 0 2px rgba(255, 77, 79, 0.2)';
        
        // Remover el estilo de error después de que se seleccione una ciudad
        const removeErrorStyle = () => {
          citySelect.style.borderColor = '';
          citySelect.style.boxShadow = '';
        };
        
        // Limpia el estilo cuando se seleccione una ciudad
        const selectElement = document.querySelector('.ant-select');
        if (selectElement) {
          selectElement.addEventListener('click', removeErrorStyle, { once: true });
        }
      }
      return;
    }

    setCotizarDisabled(true);
    setLoading(true);
    setAttemptedSubmit(true);
    setCostoEnvioButtonDisabled(false);
    if (!isTransportadoraModalOpen) {
      setCotizacionResult(null);
    }

    // Validar que el valor declarado sea al menos 25,000
    const valorDeclarado = parseFloat(formData.declaredValue);
    if (valorDeclarado < 25000) {
      message.error('El valor declarado debe ser al menos $25.000 para poder cotizar');
      setLoading(false);
      setCotizarDisabled(false);
      return;
    }

    // Validar que el peso bruto no sea 0
    const pesoBruto = parseFloat(formData.grossWeight);
    if (pesoBruto <= 0) {
      message.error('El peso bruto debe ser mayor a 0 para poder cotizar');
      setLoading(false);
      setCotizarDisabled(false);
      return;
    }

    const pesoVolumetrico = parseFloat(volumetricWeight);
    const pesoFinal = pesoVolumetrico > pesoBruto ? pesoVolumetrico : pesoBruto;

    if (errorMessage) {
      message.error(errorMessage);
      setLoading(false);
      setCotizarDisabled(false);
      return;
    }
    
    const current = new Date();
    const formattedDate = ("0" + current.getDate()).slice(-2) + "-" +
                          ("0" + (current.getMonth() + 1)).slice(-2) + "-" +
                           current.getFullYear();

    // Formatear el valor declarado para la cotización
    const cotizacionData = {
      destino: {
        nombre: "",
        codigo: formData.destinationCity,
      },
      origen: {
        nombre: "",
        codigo: "",
      },
      IdTipoEntrega: formData.deliveryType === 'direccion' ? 1 : 2,
      IdServicio: formData.shipmentType === 'normal' ? 1 : 2,
      peso: pesoFinal,
      largo: parseInt(formData.length, 10),
      ancho: parseInt(formData.width, 10),
      alto: parseInt(formData.height, 10),
      fecha: formattedDate,
      AplicaContrapago: formData.cashOnDelivery,
      valorDeclarado: parseInt(formData.declaredValue, 10),
      seguro99: formData.seguro99,
      seguro99plus: formData.seguro99plus,
    };


    try {
      const response = await fetch(`https://integration.99envios.app/api/sucursal/cotizar/${sucursalId}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(cotizacionData),
      });

      if (!response.ok) {
        throw new Error('Error en la cotización');
      }

      const result = await response.json();

      if (result && Object.keys(result).length > 0) {
        if (formData.deliveryType === 'centroAcopio') {
          // Si es entrega en oficina, solo mostrar Interrapidisimo
          if (result.interrapidisimo) {
            setCotizacionResult({ interrapidisimo: result.interrapidisimo });
          } else {
            message.error('No hay servicio de entrega en oficina disponible para esta ciudad');
            setLoading(false);
            setCotizarDisabled(false);
            return;
          }
        } else {
          // Para entrega a domicilio, mostrar todas las transportadoras
          setCotizacionResult(result);
        }
        setIsTransportadoraModalOpen(true);
      } else {
        message.error('No se obtuvieron resultados de cotización válidos');
      }
    } catch (error) {
      console.error('Error:', error);
      alert('Hubo un error al realizar la cotización');
    } finally {
      setLoading(false);
      setTimeout(() => {
        setCotizarDisabled(false);
      }, 3000);
    }
  };

  const copyFormDataToGuia = () => {
    setFormDataGuia({
      ...formDataGuia,
      Peso: formData.grossWeight,
      Largo: formData.length,
      Ancho: formData.width,
      Alto: formData.height,
      DiceContener: formData.contentDescription,
      ValorDeclarado: formData.declaredValue,
      AplicaContrapago: formData.cashOnDelivery,
      seguro99: formData.seguro99,
      seguro99plus: formData.seguro99plus,
      idLocalidad: formData.destinationCity
    });
  };

  const handleSelectTransportadora = (transportadora) => {
    setSelectedTransportadora(transportadora);
    openModal();
  };

  const openModal = () => {
    const pesoBruto = parseFloat(formData.grossWeight);
    const pesoVolumetrico = parseFloat(volumetricWeight);
    const pesoFinal = pesoVolumetrico > pesoBruto ? pesoVolumetrico : pesoBruto;
    setFinalWeight(pesoFinal.toFixed(2));
    copyFormDataToGuia();
    // En dispositivos móviles, cerramos primero el modal de cotización
    if (isResponsive) {
      setModalIsOpen(false);
      // Pequeño retraso para evitar problemas de renderizado
      setTimeout(() => {
        setGuiaModalIsOpen(true);
      }, 300);
    } else {
      setGuiaModalIsOpen(true);
    }
  };

  const [availableBalance, setAvailableBalance] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchAvailableBalance = async () => {
      try {
        const user_id = localStorage.getItem('usuario_id');
        const token = localStorage.getItem('token');

        const response = await fetch(`https://99envios.app/api/online/consultar-saldo/${user_id}`, {
          method: 'GET',
          headers: {
            'Authorization': token ? `Bearer ${token}` : '',
            'Content-Type': 'application/json'
          }
        });

        if (!response.ok) throw new Error('Failed to fetch balance');

        const data = await response.json();
        setAvailableBalance(data.saldo_disponible);
      } catch (err) {
        setError('Error al obtener el saldo disponible');
        console.error(err);
      }
    };

    fetchAvailableBalance();
  }, []);

  const updateAvailableBalance = async () => {
    const user_id = localStorage.getItem('usuario_id');
    const token = localStorage.getItem('token');

    try {
      const response = await fetch(`https://99envios.app/api/online/consultar-saldo/${user_id}`, {
        method: 'GET',
        headers: {
          'Authorization': token ? `Bearer ${token}` : '',
          'Content-Type': 'application/json'
        }
      });

      if (!response.ok) throw new Error('Failed to fetch balance');

      const data = await response.json();
      setAvailableBalance(data.saldo_disponible);
    } catch (err) {
      console.error('Error al actualizar el saldo disponible:', err);
    }
  };

  useEffect(() => {
    if (isResponsive && cotizacionResult) {
      setModalIsOpen(true);
    }
  }, [isResponsive, cotizacionResult]);

  const formatBalance = (balance) => {
    if (balance === null) return '99';
    const absBalance = Math.abs(balance);
    const formattedBalance = absBalance.toLocaleString('es-CO', {
      style: 'currency',
      currency: 'COP',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    });
    return balance < 0 ? `-${formattedBalance}` : formattedBalance;
  };

  useEffect(() => {
    if (formData.deliveryType === 'centroAcopio' && formData.destinationCity) {
      const fetchOffices = async () => {
        try {
          const response = await fetch(`https://integration.99envios.app/api/sucursal/oficinas/${formData.destinationCity}`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({ city: formData.destinationCity }),
          });
          if (!response.ok) {
            throw new Error('Error obteniendo las oficinas');
          }
          const data = await response.json();
          setOffices(data);
        } catch (error) {
          console.error('Error obteniendo las oficinas:', error);
        }
      };

      fetchOffices();
    }
  }, [formData.deliveryType, formData.destinationCity]);

  const handleOfficeChange = (value) => {
    setSelectedOffice(value);
    const selectedOffice = offices.find(office => office.CentroServicio.IdCentroServicio === value);
    if (selectedOffice) {
      setFormDataGuia(prevState => ({
        ...prevState,
        direccion: `${selectedOffice.CentroServicio.Direccion} (OFC: ${selectedOffice.CentroServicio.IdCentroServicio})`
      }));
    }
  };

  const [isModalVisible, setIsModalVisible] = useState(false);

  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  // Automatically open the modal when cotizacionResult is set
  useEffect(() => {
    if (cotizacionResult) {
      setModalIsOpen(true);
    }
  }, [cotizacionResult]);

  return (
    <>
      <NavbarMex title="Guías Unitarias" />
      
      {/* <div
        className={`shipping-form-saldo-disponible-unitarias ${availableBalance <= 0 ? 'red-background-unitarias' : ''}`}
      >
        <p className="saldo-text-unitarias palpitating-unitarias">
          <span style={{ color: "#4c45b1" }}>Saldo Disponible:</span>{' '}
          {formatBalance(availableBalance)}
        </p>
      </div> */}

      {/* Añadimos el componente ManifiestoGenerator debajo del saldo disponible */}
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center',
        marginBottom: '15px'
      }}>
        <ManifiestoGenerator 
          buttonText="Generar Manifiesto" 
          buttonStyle={{ 
            marginRight: '-213px',
            marginBottom: '-23px',
            backgroundColor: '#217346'
          }}
        />
      </div>

      <div className="shipping-form-main-container-unitarias">
        <div className="shipping-form-container-unitarias">
          <form onSubmit={handleSubmit} className="shipping-form-unitarias" id="myForm">
            {modalMessage && modalMessage.activo && (
              <Alert 
                message={modalMessage.mensaje} 
                type="info" 
                closable 
                style={{ marginBottom: '16px' }}
              />
            )}
            <h2>InformaciOn del destino</h2>

            {/* Reemplazar el Alert con un Modal */}
            <Modal
              title="Error"
              visible={isErrorModalVisible}
              onCancel={handleErrorModalCancel}
              footer={null}
              className="error-modal"
              destroyOnClose={true}
              style={{ top: 20, zIndex: 10000000 }} // Asegurar que el modal de error esté por encima de todo
            >
              <p>{errorModalMessage}</p>
              <p>Saldo Disponible: {formatBalance(availableBalance)}</p>
            </Modal>

            <Modal
              title="Instructivo de Guías Unitarias"
              visible={isModalVisible}
              onCancel={handleCancel}
              footer={null}
              destroyOnClose={true}
              width="100vh"
              style={{ top: 20 }}
              bodyStyle={{ padding: 0 }}
            >
              <div style={{ position: 'relative', paddingBottom: '65%', height: 0, overflow: 'hidden' }}>
                <iframe
                  width="100%"
                  height="100%"
                  src="https://www.youtube.com/embed/teZ8zhbWOKA?si=9YEGdL4vKEfcrOdY"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                  style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                  }}
                ></iframe>
              </div>
            </Modal>

            <div className="form-row-unitarias">
              <div className="form-group-guias-unitarias">
                <label htmlFor="destinationCity">Ciudad destino</label>
                <Select
                  id="destinationCity"
                  name="destinationCity"
                  value={formData.destinationCity}
                  onChange={(value) => handleChange({ target: { name: 'destinationCity', value } })}
                  style={{
                    padding: '3px',
                    marginBottom: '10px',
                  }}
                  required
                  showSearch
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    option.children.toLowerCase().includes(input.toLowerCase())
                  }
                >
                  <option value="" disabled>
                    Seleccione una ciudad
                  </option>
                  {Ciudades.map((ciudad) => (
                    <Option key={ciudad.value} value={ciudad.value}>
                      {ciudad.label}
                    </Option>
                  ))}


                </Select>
              </div>
            </div>
            <div className="form-row-unitarias">
              <div className="form-group-guias-unitarias">
                <label htmlFor="deliveryType">Tipo de Entrega</label>
                <select
                  id="deliveryType"
                  name="deliveryType"
                  value={formData.deliveryType}
                  onChange={handleChange}
                  required
                  className="input-field"
                >
                  <option value="" disabled>
                    Seleccione un tipo de entrega
                  </option>
                  <option value="direccion">ENTREGA EN DIRECCION</option>
                  <option value="centroAcopio">ENTREGA EN OFICINA</option>
                </select>
              </div>
              <div className="form-group-guias-unitarias">
                <label htmlFor="declaredValue">Valor declarado</label>
                <input
                  type="text"
                  id="declaredValue"
                  name="declaredValue"
                  value={formattedDeclaredValue}
                  onChange={handleChange}
                  required
                  className="input-field"
                />
              </div>
              <div className="form-group-guias-unitarias">
              <label htmlFor="declaredValue">Tamaño de guía</label>
                <select
                  className="input-field"
                  value={selectedTamanoGuia}
                  onChange={(e) => setSelectedTamanoGuia(e.target.value)}
                >
                  <option value="1">Sticker</option>
                  <option value="2">Media Carta</option>
                </select>
              </div>
            </div>
            <div className="form-row-unitarias">
              <div className="form-group-guias-unitarias">
                <label htmlFor="grossWeight">Peso Bruto</label>
                <input
                  type="number"
                  id="grossWeight"
                  name="grossWeight"
                  value={formData.grossWeight}
                  onChange={handleChange}
                  placeholder="Ingrese el peso bruto"
                  required
                  className="input-field"
                />
              </div>
              <div className="form-group-guias-unitarias">
                <label htmlFor="length">Largo</label>
                <input
                  type="number"
                  id="length"
                  name="length"
                  value={formData.length}
                  onChange={handleChange}
                  placeholder="Ingrese el largo"
                  required
                  className="input-field"
                />
              </div>
              <div className="form-group-guias-unitarias">
                <label htmlFor="width">Ancho</label>
                <input
                  type="number"
                  id="width"
                  name="width"
                  value={formData.width}
                  onChange={handleChange}
                  placeholder="Ingrese el ancho"
                  required
                  className="input-field"
                />
              </div>
              <div className="form-group-guias-unitarias">
                <label htmlFor="height">Alto</label>
                <input
                  type="number"
                  id="height"
                  name="height"
                  value={formData.height}
                  onChange={handleChange}
                  placeholder="Ingrese el alto"
                  required
                  className="input-field"
                />
              </div>
              <div className="form-group-guias-unitarias">
                <label htmlFor="volumetricWeight">Peso Volumétrico</label>
                <input
                  type="number"
                  id="volumetricWeight"
                  name="volumetricWeight"
                  value={volumetricWeight}
                  readOnly
                  className="input-field"
                />
              </div>
            </div>
            <div className="form-row-unitarias">
              <div className="form-group-guias-unitarias checkbox-wrapper-unitarias">
                <div className="checkbox-row-unitarias">
                  <label className="checkbox-label-unitarias">
                    <input
                      type="checkbox"
                      id="cashOnDelivery"
                      name="cashOnDelivery"
                      checked={formData.cashOnDelivery}
                      onChange={handleChange}
                      className="custom-checkbox-unitarias"
                    />
                    <span className="checkbox-custom-unitarias"></span>
                    <span className="checkbox-text-unitarias">Pago Contra Entrega</span>
                  </label>
                  <label
                    className={`checkbox-label-unitarias`}
                  >
                    <input
                      type="checkbox"
                      id="seguro99"
                      name="seguro99"
                      checked={formData.seguro99}
                      onChange={handleChange}
                      className="custom-checkbox-unitarias"
                      
                    />
                    <span className="checkbox-custom-unitarias"></span>
                    <span
                      className="checkbox-text-unitarias"
                      style={{
                        pointerEvents: "auto",
                      }}
                    >
                      Seguro Antidevolución
                      <Tooltip
                        /* title={
                         seguroPayMessage ? "🛡️ Seguro Antidevoluciones. El valor del seguro será cobrado en caso de generarse una devolución o entrega." : "🛡️ Seguro Antidevoluciones Protege tus envíos ante devoluciones por no entrega, rechazo o falta de pago."
                        } */
                       title="🛡️ Seguro Antidevoluciones. El valor del seguro será cobrado en caso de generarse una devolución o entrega."
                      >
                        <InfoCircleOutlined
                          style={{
                            marginLeft: "5px",
                            color: "#4c45b1",
                            cursor: "help",
                          }}
                        />
                      </Tooltip>
                    </span>
                  </label>
                  <label
                    className={`checkbox-label-unitarias`}
                  >
                    <input
                      type="checkbox"
                      id="seguro99plus"
                      name="seguro99plus"
                      checked={formData.seguro99plus}
                      onChange={handleChange}
                      className="custom-checkbox-unitarias"
                      
                    />
                    <span className="checkbox-custom-unitarias"></span>
                    <span
                      className="checkbox-text-unitarias"
                      style={{
                        pointerEvents: "auto",
                      }}
                    >
                      Seguro Antidevolución Plus
                      <Tooltip
                        /* title={
                         seguroPayMessage ? "🛡️ Seguro Antidevoluciones. El valor del seguro será cobrado en caso de generarse una devolución o entrega." : "🛡️ Seguro Antidevoluciones Protege tus envíos ante devoluciones por no entrega, rechazo o falta de pago."
                        } */
                       title=" Seguro Antidevolución Plus. En caso de una devolución, no asumes ningún costo: no pagas el envío de ida, ni el de regreso, ni el valor del seguro. El costo total es cero."
                      >
                        <InfoCircleOutlined
                          style={{
                            marginLeft: "5px",
                            color: "#4c45b1",
                            cursor: "help",
                          }}
                        />
                      </Tooltip>
                    </span>
                  </label>
                </div>
              </div>
            </div>
            <button
              type="submit"
              className="submit-button-unitarias"
              style={{ marginLeft: '0px' }}
              disabled={!!errorMessage || cotizarDisabled}
            >
              {cotizarDisabled ? 'Cotizando...' : 'Cotizar'}
            </button>
            {loading && <div className="loading-spinner"></div>}
          </form>
        </div>

        {cotizacionResult && !isResponsive && (
          <div className="cotizacion-result-container-unitarias">
            <h2>Selecciona tu Transportadora</h2>
            <button
              className="transportadora-select-btn"
              onClick={() => setIsTransportadoraModalOpen(true)}
              style={{ margin: '10px 0' }}
            >
              <FontAwesomeIcon icon={faTruck} /> Ver Transportadoras Disponibles
            </button>
          </div>
        )}

        <ReactModal
          isOpen={(isTransportadoraModalOpen || (isResponsive && modalIsOpen)) && cotizacionResult !== null}
          onRequestClose={() => {
            if (isResponsive) {
              setModalIsOpen(false);
            }
            setIsTransportadoraModalOpen(false);
            setCotizacionResult(null);
            setSelectedTransportadora(null);
            setActiveCarrier(null);
            setCostoEnvioButtonDisabled(false);
            setFormData(prevState => ({
              ...prevState,
              declaredValue: '50000'
            }));
            setFormattedDeclaredValue(formatCurrency(50000));
          }}
          className="transportadoras-modal"
          overlayClassName="custom-overlay-unitarias"
          style={{ zIndex: 9999 }}
          contentLabel="Selección de Transportadoras"
        >
          {cotizacionResult && (
            <>
              <div className="transportadoras-modal-header">
                <h2>Selecciona tu Transportadora</h2>
                <button
                  className="transportadoras-modal-close"
                  onClick={() => {
                    if (isResponsive) {
                      setModalIsOpen(false);
                    }
                    setIsTransportadoraModalOpen(false);
                    setCotizacionResult(null);
                    setSelectedTransportadora(null);
                    setActiveCarrier(null);
                    setCostoEnvioButtonDisabled(false);
                    setFormData(prevState => ({
                      ...prevState,
                      declaredValue: '50000'
                    }));
                    setFormattedDeclaredValue(formatCurrency(50000));
                  }}
                >
                  &times;
                </button>
              </div>
              <div className="transportadoras-modal-body">
                <div className="transportadoras-container-horizontal">
                  {cotizacionResult && 
                    [...Object.entries(cotizacionResult)]
                      .sort((a, b) => {
                        const order = ['interrapidisimo', 'coordinadora', 'tcc', 'servientrega'];
                        return order.indexOf(a[0]) - order.indexOf(b[0]);
                      })
                      .map(([name, data]) => {
                        if (!data) return null;
                        const valorDeclarado = parseFloat(formData.declaredValue || 0);
                        const total = (data.valor || 0) + 
                                    (data.sobreflete || 0) + 
                                    (data.valor_contrapago || 0) + 
                                    (data.seguro99 || 0);
                        const valorACobrar = valorDeclarado - total;

                        return (
                          <div
                            key={name}
                            className={`transportadora-card-horizontal ${selectedTransportadora === name ? 'selected' : ''} ${(costoEnvioButtonDisabled && activeCarrier && activeCarrier !== name) ? 'disabled' : ''}`}
                            onClick={() => !costoEnvioButtonDisabled && handleSelectTransportadora(name)}
                            style={{
                              opacity: (costoEnvioButtonDisabled && activeCarrier && activeCarrier !== name) ? '0.6' : '1',
                              pointerEvents: (costoEnvioButtonDisabled && activeCarrier && activeCarrier !== name) ? 'none' : 'auto',
                              cursor: (costoEnvioButtonDisabled && activeCarrier && activeCarrier !== name) ? 'not-allowed' : 'pointer'
                            }}
                          >
                            <div className="transportadora-logo-horizontal">
                              <img src={getTransportadoraImage(name)} alt={name} onError={(e) => {
                                console.error(`Error loading image for ${name}`);
                                e.target.src = '/Images/default.png';
                              }} />
                            </div>
                            <div className="transportadora-info-horizontal">
                              <div className="transportadora-details">
                                <span className="transportadora-name">{name.charAt(0).toUpperCase() + name.slice(1)}</span>
                              </div>
                              <div className="price-breakdown">
                                {formData.cashOnDelivery ? (
                                  <>
                                    <div className="price-item">
                                      <span>Valor a recibir:</span>
                                      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                        <span className="amount">${valorDeclarado.toLocaleString()}</span>
                                      </div>
                                    </div>
                                    <div className="price-item">
                                      <span>Costo del envío:</span>
                                      <span className="amount negative">-${total.toLocaleString()}</span>
                                    </div>
                                    <div className="price-item total">
                                      <span>Tu ganancia:</span>
                                      <span className="amount">${valorACobrar.toLocaleString()}</span>
                                    </div>                                      <button
                                      onClick={async (e) => {
                                        if (costoEnvioButtonDisabled || (activeCarrier && activeCarrier !== name)) return;
                                        const isButtonDisabled = costoEnvioButtonDisabled || (activeCarrier && activeCarrier !== name);
                                        e.stopPropagation();
                                        e.preventDefault();
                                        const buttonElement = e.currentTarget;
                                        // Disable immediately to prevent multiple clicks
                                        buttonElement.disabled = true;
                                        setCostoEnvioButtonDisabled(true);
                                        setActiveCarrier(name);
                                        buttonElement.innerHTML = '<span class="anticon anticon-loading anticon-spin" style="margin-right: 8px;"></span>Recalculando...';
                                        console.log('Costo de envío original:', total);
                                        const adjustedTotal = total + (total * 0.090); // Sumar el costo de envío más el 8.6%
                                        console.log('Costo de envío ajustado (108.6%):', adjustedTotal);
                                        const newDeclaredValue = valorDeclarado + adjustedTotal;
                                        console.log('Nuevo valor declarado:', newDeclaredValue, 'Valor declarado original:', valorDeclarado);
                                        // Actualizar directamente el valor declarado en la cotización
                                        const fakeEvent = { preventDefault: () => {} };
                                        try {
                                          await setFormData(prev => ({...prev, declaredValue: newDeclaredValue.toString()}));
                                          setFormattedDeclaredValue(formatCurrency(newDeclaredValue));
                                          
                                          // Hacer la petición con el nuevo valor
                                          const current = new Date();
                                          const formattedDate = ("0" + current.getDate()).slice(-2) + "-" +
                                                              ("0" + (current.getMonth() + 1)).slice(-2) + "-" +
                                                              current.getFullYear();
                                          
                                          const pesoBruto = parseFloat(formData.grossWeight);
                                          const pesoVolumetrico = parseFloat(volumetricWeight);
                                          const pesoFinalRecalc = pesoVolumetrico > pesoBruto ? pesoVolumetrico : pesoBruto;

                                          const cotizacionData = {
                                            destino: {
                                              nombre: "",
                                              codigo: formData.destinationCity,
                                            },
                                            origen: {
                                              nombre: "",
                                              codigo: "",
                                            },
                                            IdTipoEntrega: formData.deliveryType === 'direccion' ? 1 : 2,
                                            IdServicio: formData.shipmentType === 'normal' ? 1 : 2,
                                            peso: pesoFinalRecalc,
                                            largo: parseInt(formData.length, 10),
                                            ancho: parseInt(formData.width, 10),
                                            alto: parseInt(formData.height, 10),
                                            fecha: formattedDate,
                                            AplicaContrapago: formData.cashOnDelivery,
                                            valorDeclarado: newDeclaredValue,
                                            seguro99: formData.seguro99,
                                            seguro99plus: formData.seguro99plus,
                                          };
                                          
                                          const response = await fetch(`https://integration.99envios.app/api/sucursal/cotizar/${sucursalId}`, {
                                            method: 'POST',
                                            headers: {
                                              'Content-Type': 'application/json',
                                            },
                                            body: JSON.stringify(cotizacionData),
                                          });
                                          
                                          if (!response.ok) {
                                            throw new Error('Error en la cotización');
                                          }
                                          
                                          const result = await response.json();
                                          if (result && Object.keys(result).length > 0) {
                                            setCotizacionResult(result);
                                          }
                                          // Actualizar botón después de la recotización exitosa
                                          buttonElement.innerHTML = 'Costo de envío sumado';
                                          buttonElement.style.backgroundColor = '#a8a5d2';
                                          buttonElement.style.cursor = 'not-allowed';
                                          buttonElement.disabled = true;
                                          setCostoEnvioButtonDisabled(true);
                                        } catch (error) {
                                          console.error('Error recalculando:', error);
                                          message.error('Error al recalcular');
                                          // Restaurar el botón en caso de error
                                          buttonElement.innerHTML = 'Costo de envío sumado';
                                          buttonElement.style.backgroundColor = '#a8a5d2';
                                          buttonElement.style.cursor = 'not-allowed';
                                          buttonElement.disabled = true;
                                          setCostoEnvioButtonDisabled(false);
                                          setActiveCarrier(null);
                                        }
                                      }}
                                      className="edit-value-btn"
                                      style={{
                                        background: costoEnvioButtonDisabled ? '#a8a5d2' : '#4a90e2',
                                        border: 'none',
                                        borderRadius: '4px',
                                        color: 'white',
                                        padding: '5px 10px',
                                        marginTop: '10px',
                                        cursor: costoEnvioButtonDisabled ? 'not-allowed' : 'pointer',
                                        width: '100%'
                                      }}
                                      disabled={costoEnvioButtonDisabled}
                                    >
                                      Sumar costo de envío
                                    </button>
                                  </>
                                ) : (
                                  <div className="price-item total">
                                    <span>Costo del envío:</span>
                                    <span className="amount">${total.toLocaleString()}</span>
                                  </div>
                                )}
                              </div>                                      <button
                                className="transportadora-select-btn-horizontal"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleSelectTransportadora(name);
                                }}
                                disabled={costoEnvioButtonDisabled && activeCarrier !== name}
                                style={{
                                  backgroundColor: (costoEnvioButtonDisabled && activeCarrier !== name) ? '#a8a5d2' : '#4c45b1',
                                  cursor: (costoEnvioButtonDisabled && activeCarrier !== name) ? 'not-allowed' : 'pointer'
                                }}
                              >
                                Seleccionar
                              </button>
                            </div>
                          </div>
                        );
                      })
                  }
                </div>
              </div>
            </>
          )}
        </ReactModal>

      </div>

      <ReactModal 
        isOpen={guiaModalIsOpen && selectedTransportadora} 
        onRequestClose={closeModal} 
        className="custom-modal-unitarias" 
        overlayClassName="custom-overlay-unitarias"
        style={{ zIndex: 9999 }} // Aumentamos el z-index para asegurarnos que esté por encima de todo
      >
        <div className="modal-header-unitarias">
          <h2>Completar Información para Generar la Guía</h2>
          <button type="button" className="close-button-unitarias" onClick={closeModal}>
            &times;
          </button>
        </div>
        <form>
          {formData.deliveryType === 'centroAcopio' && (
            <div className="modal-form-row">
              <div className="modal-form-group-guias">
                <label htmlFor="numeroDocumento" className="required-label">Número de Documento (Destinatario) <span className="required-asterisk">*</span></label>
                <input
                  type="text"
                  id="numeroDocumento"
                  name="numeroDocumento"
                  value={formDataGuia.numeroDocumento}
                  onChange={handleInputChange}
                  required
                  className="input-field"
                  placeholder="Ingrese el número de documento"
                />
              </div>
            </div>
          )}
          
          <div className="modal-form-row">
            <div className="modal-form-group-guias">
              <label htmlFor="nombre" className="required-label">Nombre (Destinatario) <span className="required-asterisk">*</span></label>
              <input
                type="text"
                id="nombre"
                name="nombre"
                value={formDataGuia.nombre}
                onChange={handleInputChange}
                required
                className="input-field"
                placeholder="Ingrese el nombre del destinatario"
              />
            </div>
          </div>

          <div className="modal-form-row">
            <div className="modal-form-group-guias">
              <label htmlFor="primerApellido" className="required-label">Primer Apellido (Destinatario) <span className="required-asterisk">*</span></label>
              <input
                type="text"
                id="primerApellido"
                name="primerApellido"
                value={formDataGuia.primerApellido}
                onChange={handleInputChange}
                required
                className="input-field"
                placeholder="Ingrese el primer apellido"
              />
            </div>
          </div>

          <div className="modal-form-row">
            <div className="modal-form-group-guias">
              <label htmlFor="telefono" className="required-label">Teléfono (Destinatario) <span className="required-asterisk">*</span></label>
              <input
                type="text"
                id="telefono"
                name="telefono"
                value={formDataGuia.telefono}
                onChange={handleInputChange}
                required
                className="input-field"
                placeholder="Ingrese el teléfono de contacto"
              />
            </div>
          </div>

          <div className="modal-form-row">
            <div className="modal-form-group-guias">
              {formData.deliveryType === 'centroAcopio' ? (
                <>
                  <label htmlFor="office" className="required-label">Oficina de Entrega <span className="required-asterisk">*</span></label>
                  <Select
                    id="office"
                    name="office"
                    value={selectedOffice}
                    onChange={handleOfficeChange}
                    required
                    className="input-field"
                    style={{ width: '100%' }}
                    dropdownStyle={{ zIndex: 10000 }} // Ensure dropdown is visible
                    placeholder="Seleccione una oficina"
                  >
                    {offices.map(office => (
                      <Option key={office.CentroServicio.IdCentroServicio} value={office.CentroServicio.IdCentroServicio}>
                        {office.CentroServicio.Direccion}
                      </Option>
                    ))}
                  </Select>
                </>
              ) : (
                <>
                  <label htmlFor="direccion" className="required-label">Dirección de entrega <span className="required-asterisk">*</span></label>
                  <input
                    type="text"
                    id="direccion"
                    name="direccion"
                    value={formDataGuia.direccion}
                    onChange={handleInputChange}
                    required
                    className="input-field"
                    placeholder="Casa/Torre/Apto/Barrio"
                  />
                </>
              )}
            </div>
          </div>

          <div className="modal-form-row">
            <div className="modal-form-group-guias">
              <label htmlFor="correo" className="required-label">Correo Electrónico (Destinatario) <span className="required-asterisk">*</span></label>
              <input
                type="email"
                id="correo"
                name="correo"
                value={formDataGuia.correo}
                onChange={handleInputChange}
                required
                className="input-field"
                placeholder="ejemplo@correo.com"
              />
              {emailError && <div className="email-error" style={{ position: 'relative', zIndex: 10001 }}>{emailError}</div>}
            </div>
          </div>

          <div className="modal-form-row">
            <div className="modal-form-group-guias">
              <label htmlFor="DiceContener" className="required-label">Dice contener <span className="required-asterisk">*</span></label>
              <input
                type="text"
                id="DiceContener"
                name="DiceContener"
                value={formDataGuia.DiceContener}
                onChange={handleInputChange}
                required
                className="input-field"
                placeholder="Descripción del contenido"
              />
            </div>
          </div>

          <button
            type="button"
            className="generate-button"
            onClick={handleGuiaSubmit}
            disabled={generarGuiaDisabled}
          >
            {generarGuiaDisabled ? 'Generando Guía...' : 'Generar Guía'}
          </button>
        </form>
      </ReactModal>
      
      {confirmationMessage && (
        <div
          className="confirmation-message"
          ref={confirmationRef}
          onClick={() => {
            setConfirmationMessage('');
            window.location.reload();
          }}
          style={{
            position: 'fixed',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            backgroundColor: '#ffffff',
            padding: '30px',
            borderRadius: '10px',
            boxShadow: '0 4px 8px rgba(0, 0, 0, 2)',
            textAlign: 'center',
            zIndex: '1000',
            maxWidth: '500px',
            fontSize: '100px',
            cursor: 'pointer'
          }}
        >
          <p style={{ fontSize: '18px', lineHeight: '1.5', whiteSpace: 'pre-line' }}>
            {confirmationMessage}
          </p>
          <p style={{ fontSize: '14px', marginTop: '10px' }}>
            Para cerrar haz click aquí o fuera de este cuadro.
          </p>
        </div>
      )}

      <Modal
        title="Confirmación de WhatsApp"
        visible={isWhatsappModalVisible}
        onCancel={() => setIsWhatsappModalVisible(false)}
        footer={[
          <Button key="ok" type="primary" onClick={() => setIsWhatsappModalVisible(false)}>
            OK
          </Button>
        ]}
      >
        <p>Se ha enviado un mensaje de WhatsApp de confirmación al número: {whatsappNumber}</p>
      </Modal>
      <Modal
        centered
        width={480}
        className="seguro99-warning-modal"
        footer={null}
        open={isVisibleModalWarning}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "8px",
            color: "#f5a623",
            marginBottom: "0",
          }}
        >
          <WarningOutlined style={{ fontSize: "20px" }} />
          <span style={{ fontSize: "16px", fontWeight: "500" }}>
            Seguro Antidevoluciones desactivado
          </span>
        </div>
        <div
          style={{
            marginTop: "16px",
            background: "#fff9e6",
            padding: "16px",
            borderRadius: "8px",
            border: "1px solid #ffd666",
          }}
        >
          <p
            style={{
              margin: 0,
              color: "#595959",
              fontSize: "14px",
              textAlign: "center",
              lineHeight: "1.5",
            }}
          >
            🚨 Hola! Desde 99envíos.com queremos contarte algo importante: Hemos
            notado que tu cuenta ha superado el porcentaje de devoluciones
            aceptable para mantener activo el seguro antidevolución 🛡 Para
            ayudarte a mejorar ese indicador y recuperar el beneficio, te
            invitamos a una capacitación personalizada 📚 👉 Ingresa aquí para
            agendarla:{" "}
            <a href="https://99envios.app/dashboard99?seguro99=true">
              {/* https://99envios.com/capacitacion/ */}
              Click aquí
            </a>{" "}
            <br />
            Con gute apoyamos para que puedas seguir enviando con todas las
            ventajas que te ofrece nuestra plataforma 
          </p>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: "20px",
            }}
          >
            <Button
              style={{
                backgroundColor: "#f5a623",
                borderColor: "#f5a623",
                borderRadius: "4px",
                height: "32px",
                fontWeight: "500",
              }}
              type="primary"
              onClick={() => {
                setIsVisibleModalWarning(false);
                setFormData((prevState) => ({
                  ...prevState,
                  seguro99: false,
                })); 
              }}
            >
              Ententido
            </Button>
          </div>
        </div>
      </Modal>
      <BotonWhatsapp />

    </>
  );
};

export default ShippingForm;